<template>
  <div id="PotentialClientProfileContainer">
    <b-form ref="PotentialClientProfileForm" @submit="onSubmit">
      <div role="tablist">
        <b-card no-body>
          <b-card-header header-tag="header" class="p-1" role="tab" bg-variant="primary">
            <b-button block href="#" v-b-toggle.accordion-BasicInfo variant="danger">個人資料</b-button>
          </b-card-header>
          <b-collapse
            id="accordion-BasicInfo"
            accordion="my-accordion"
            role="tabpanel"
            v-model="visbleFirstBlock"
          >
            <b-card-body>
              <b-card-text>
                <b-form-group label="中文姓名" label-for="input-cName">
                  <b-form-input
                    id="input-cName"
                    v-model="form.BasicInfo.ChineneName"
                    required
                    placeholder="請輸入中文姓名"
                    maxlength="30"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="英文姓名" label-for="input-eName">
                  <b-form-input
                    id="input-eName"
                    v-model="form.BasicInfo.LastName"
                    required
                    placeholder="請輸入英文姓"
                    maxlength="20"
                  ></b-form-input>
                  <b-form-input
                    id="input-eName"
                    v-model="form.BasicInfo.FirstName"
                    required
                    placeholder="請輸入英文名"
                    maxlength="20"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="性別" label-for="radio-group-1">
                  <b-form-radio-group
                    id="radio-group-1"
                    v-model="form.BasicInfo.Sex"
                    :options="sexs"
                  ></b-form-radio-group>
                </b-form-group>
                <b-form-group label="身份證字號" label-for="input-IDNumber">
                  <b-form-input
                    id="input-IDNumber"
                    v-model="form.BasicInfo.IdentityNumber"
                    required
                    placeholder="請輸入身份證字號"
                    maxlength="10"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="生日" label-for="input-birthday">
                  <datetime
                    input-id="birthdayPicker"
                    v-model="form.BasicInfo.Birthday"
                    required
                    :max-datetime="maxDay()"
                  ></datetime>
                </b-form-group>
                <b-form-group label="手機" label-for="input-cellphone">
                  <b-button variant="danger" @click="PhoneClick">顯示聯絡方式</b-button>
                  <b-container fluid>
                    <b-row v-if="DisplayPhone">
                      <b-col cols="4" class="padding-zero">
                        <b-form-input
                          id="input-PhoneCode"
                          v-model="form.contactInfo.PhoneCode"
                          placeholder="請輸入前4碼"
                          type="number"
                          required
                          :formatter="formatMax4"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="8" style="padding-right: 0;">
                        <b-form-input
                          id="input-Phone"
                          v-model="form.contactInfo.Phone"
                          placeholder="請輸入後6碼"
                          type="number"
                          required
                          :formatter="formatMax6"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-form-group>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.accordion-contactInfo variant="danger">個人聯絡資訊</b-button>
          </b-card-header>
          <b-collapse id="accordion-contactInfo" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-form-group label="住家電話" label-for="input-telePhone">
                  <b-button variant="danger" @click="TelPhoneClick">顯示聯絡方式</b-button>
                  <b-container fluid>
                    <b-row v-if="DisplayTelPhone">
                      <b-col cols="4" class="padding-zero">
                        <b-form-input
                          id="input-PhoneCode"
                          v-model="form.contactInfo.HomeTelCode"
                          placeholder="請輸入區碼"
                          type="number"
                          :formatter="formatMax2"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="8" style="padding-right: 0;">
                        <b-form-input
                          id="input-Phone"
                          v-model="form.contactInfo.HomeTel"
                          placeholder="請輸入住家電話"
                          type="number"
                          :formatter="formatMax8"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-form-group>

                <b-form-group label="其他電話" label-for="input-otherPhone">
                  <b-button variant="danger" @click="OtherPhoneClick">顯示聯絡方式</b-button>
                  <b-form-input
                    v-if="DisplayOtherPhone"
                    id="input-otherPhone"
                    v-model="form.contactInfo.OtherPhone"
                    placeholder="請輸入其他電話"
                    :formatter="formatMax15"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="通訊地址(發票地址)" label-for="input-mailingAddress">
                  <b-container fluid>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-select
                          @change="ProvinceChange($event,'ContactAddress')"
                          id="input-ContactAddressProvince"
                          v-model="form.contactInfo.ContactAddressProvince"
                          :options="ContactAddressProvince"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-select
                          @change="AreaChange($event,'ContactAddress')"
                          id="input-ContactAddressArea"
                          v-model="form.contactInfo.ContactAddressArea"
                          :options="ContactAddressArea"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-select
                          id="input-ContactAddressRegion"
                          v-model="form.contactInfo.ContactAddressRegion"
                          :options="ContactAddressRegion"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-input
                          id="input-mailingAddress"
                          v-model="form.contactInfo.ContactAddress"
                          placeholder="請輸入通訊地址(發票地址)"
                          maxlength="200"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-form-group>
                <b-form-group label="居住地址" label-for="input-residentialAddress">
                  <b-container fluid>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-select
                          @change="ProvinceChange($event,'Address')"
                          id="input-AddressProvince"
                          v-model="form.contactInfo.AddressProvince"
                          :options="AddressProvince"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-select
                          @change="AreaChange($event,'Address')"
                          id="input-AddressArea"
                          v-model="form.contactInfo.AddressArea"
                          :options="AddressArea"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-select
                          id="input-AddressRegion"
                          v-model="form.contactInfo.AddressRegion"
                          :options="AddressRegion"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-input
                          id="input-mailingAddress"
                          v-model="form.contactInfo.Address"
                          placeholder="請輸入居住地址"
                          maxlength="200"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-form-group>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- <b-card no-body>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.accordion-account variant="danger">學習帳號</b-button>
          </b-card-header>
          <b-collapse id="accordion-account" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-form-group label="帳號" label-for="input-account">
                  <b-form-input
                    id="input-account"
                    v-model="form.contactInfo.Email"
                    disabled="disabled"
                  ></b-form-input>
                </b-form-group>
                <b-form-group>
                  <b-button block variant="outline-danger">重設為隨機密碼</b-button>
                  <b-button block variant="outline-danger">重設為預設密碼</b-button>
                </b-form-group>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>-->

        <b-card no-body>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.accordion-companyInfo variant="danger">公司資訊</b-button>
          </b-card-header>
          <b-collapse id="accordion-companyInfo" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-form-group label="公司名稱" label-for="input-companyName">
                  <b-form-input
                    id="input-companyName"
                    v-model="form.OfficeInfo.CompanyName"
                    placeholder="請輸入公司名稱"
                    maxlength="40"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="公司職位" label-for="input-position">
                  <b-form-input
                    id="input-position"
                    v-model="form.OfficeInfo.JobTitle"
                    placeholder="請輸入公司職位"
                    maxlength="50"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="公司電話" label-for="input-companyPhone">
                  <b-container fluid>
                    <b-row>
                      <b-col cols="4" class="padding-zero">
                        <b-form-input
                          id="input-PhoneCode"
                          v-model="form.OfficeInfo.OfficeTelCode"
                          placeholder="請輸入公司電話"
                          type="number"
                          :formatter="formatMax4"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="8" style="padding-right: 0;">
                        <b-form-input
                          id="input-Phone"
                          v-model="form.OfficeInfo.OfficeTel"
                          placeholder="請輸入公司電話"
                          type="number"
                          :formatter="formatMax10"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-form-group>
                <b-form-group label="傳真電話" label-for="input-faxTelephone">
                  <b-container fluid>
                    <b-row>
                      <b-col cols="4" class="padding-zero">
                        <b-form-input
                          id="input-PhoneCode"
                          v-model="form.OfficeInfo.OfficeFaxCode"
                          placeholder="請輸入傳真"
                          type="number"
                          :formatter="formatMax4"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="8" style="padding-right: 0;">
                        <b-form-input
                          id="input-Phone"
                          v-model="form.OfficeInfo.OfficeFax"
                          placeholder="請輸入傳真"
                          type="number"
                          :formatter="formatMax10"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-form-group>
                <b-form-group label="公司地址" label-for="input-companyAddress">
                  <b-container fluid>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-select
                          @change="AreaChange($event,'OfficeAddress')"
                          id="input-AddressArea"
                          v-model="form.OfficeInfo.OfficeAddressArea"
                          :options="OfficeAddressArea"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-select
                          id="input-OfficeAddressCode"
                          v-model="form.OfficeInfo.OfficeAddressCode"
                          :options="OfficeAddressCode"
                        ></b-form-select>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col class="padding-zero">
                        <b-form-input
                          id="input-companyAddress"
                          v-model="form.OfficeInfo.OfficeAddress"
                          placeholder="請輸入公司地址"
                          maxlength="76"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-form-group>
                <!-- <b-form-group label="公司網站" label-for="input-companyWebsite">
                  <b-form-input
                    id="input-companyWebsite"
                    v-model="form.OfficeInfo.companyWebsite"
                    placeholder="請輸入公司網站"
                  ></b-form-input>
                </b-form-group>-->
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.accordion-guardianInfo variant="danger">法定代理人資訊</b-button>
          </b-card-header>
          <b-collapse id="accordion-guardianInfo" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-form-group label="法定代理人姓名" label-for="input-guardianName">
                  <b-form-input
                    id="input-guardianName"
                    v-model="form.LegalInfo.LegalName"
                    placeholder="請輸入法定代理人姓名"
                    maxlength="20"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="法定代理人身分證字號" label-for="input-guardianIDNumber">
                  <b-form-input
                    id="input-guardianIDNumber"
                    v-model="form.LegalInfo.IdentityNumber"
                    placeholder="請輸入法定代理人身分證字號"
                    maxlength="10"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="關係" label-for="input-related">
                  <b-form-input
                    id="input-related"
                    v-model="form.LegalInfo.RelationShip"
                    placeholder="請輸入法定代理人與客戶之關係"
                    maxlength="10"
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="法定代理人電話" label-for="input-guardianPhone">
                  <b-form-input
                    id="input-guardianPhone"
                    v-model="form.LegalInfo.LegalPhone"
                    type="number"
                    placeholder="請輸入法定代理人電話"
                    :formatter="formatMax20"
                  ></b-form-input>
                </b-form-group>
                <b-form-group label="法定代理人 E - mail" label-for="input-guardianEmail">
                  <b-form-input
                    id="input-guardianEmail"
                    v-model="form.LegalInfo.LegalMail"
                    placeholder="請輸入法定代理人 E - mail"
                    maxlength="50"
                  ></b-form-input>
                </b-form-group>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card no-body>
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block href="#" v-b-toggle.accordion-other variant="danger">其他</b-button>
          </b-card-header>
          <b-collapse id="accordion-other" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-form-group label="是否有可能擔任企業代言" label-for="radio-group-spokesperson">
                  <b-form-radio-group
                    id="radio-group-spokesperson"
                    v-model="form.OtherInfo.IsBehalf"
                    :options="IsBehalf"
                  ></b-form-radio-group>
                </b-form-group>
                <b-form-group label="原因" label-for="input-reason" v-if="form.OtherInfo.IsBehalf">
                  <b-form-textarea
                    id="input-reason"
                    v-model="form.OtherInfo.BehalfReason"
                    placeholder="請輸入原因"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group label="備註" label-for="input-note">
                  <b-form-textarea
                    id="input-note"
                    v-model="form.OtherInfo.Note"
                    placeholder="請輸入備註"
                  ></b-form-textarea>
                </b-form-group>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <b-form-group style="text-align:center;">
        <b-button @click="triggerSubmit()" variant="danger">確定</b-button>
      </b-form-group>
      <!-- 因為沒有辦法在檢查必填欄位之前進入submit方法，所以做一個假的按鈕進行模擬，最後再tigger submit -->
      <b-form-group style="text-align:center;" v-show="false">
        <b-button v-if="EditPermission" type="submit" variant="danger" id="sureSubmit">確定submit</b-button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { LeadHandler } from "../../handler/LeadHandler.js";
import http from "../../http.js";
import qs from "qs";
export default {
  props: ["leadSn", "staffId"],
  data() {
    return {
      EditPermission: false,
      form: {
        BasicInfo: {
          ChineneName: "",
          FirstName: "",
          LastName: "",
          Sex: "1",
          IdentityNumber: "",
          Birthday: "",
          account: ""
        },
        contactInfo: {
          citizenship: null,
          location: null,
          Phone: "",
          PhoneCode: "",
          homeTelCode: "",
          homeTel: "",
          OtherPhone: "",
          ContactAddressProvince: "",
          ContactAddressArea: "",
          ContactAddressRegion: "",
          ContactAddressCode: "",
          ContactAddress: "",
          AddressProvince: "",
          AddressArea: "",
          AddressRegion: "",
          AddressCode: "",
          Address: "",
          Email: ""
        },
        OfficeInfo: {
          CompanyName: "",
          JobTitle: "",
          OfficeTel: "",
          OfficeTelCode: "",
          OfficeFax: "",
          OfficeFaxCode: "",
          OfficeAddressCode: "",
          OfficeAddressArea: "",
          OfficeAddress: ""
        },
        LegalInfo: {
          LegalName: "",
          LegalPhone: "",
          LegalMail: "",
          RelationShip: "",
          IdentityNumber: ""
        },
        OtherInfo: {
          IsBehalf: false,
          BehalfReason: "",
          Note: ""
        }
      },
      visbleFirstBlock: true,
      sexs: [
        { text: "男", value: "1" },
        { text: "女", value: "2" }
      ],
      IsBehalf: [
        { text: "是", value: true },
        { text: "否", value: false }
      ],
      ContactAddressProvince: [],
      ContactAddressArea: [{ text: "請先選擇地區", value: null }],
      ContactAddressRegion: [{ text: "請先選擇城市", value: null }],

      AddressProvince: [],
      AddressArea: [{ text: "請先選擇地區", value: null }],
      AddressRegion: [{ text: "請先選擇城市", value: null }],

      OfficeAddressArea: [],
      OfficeAddressCode: [{ text: "請先選擇城市", value: null }],

      DisplayPhone: false,
      DisplayTelPhone: false,
      DisplayOtherPhone: false
    };
  },
  created() {
    var that = this;
    that.GetLeadProfiles();

    http
      .post(
        "Lead/QueryLeadProfilePermission",
        qs.stringify({
          leadSn: that.leadSn,
          staffId: that.staffId
        })
      )
      .then(function(response) {
        var data = response.data;
        that.EditPermission = data.Result;
      })
      .catch(function(error) {
        console.log(error);
      });
  },
  methods: {
    async QueryProvinceList() {
      var that = this;
      return await http
        .post(
          "Lead/GetProvinceList",
          qs.stringify({
            staffId: that.staffId
          })
        )
        .then(function(response) {
          var data = response.data;

          data.unshift({
            text: "請選擇地區",
            value: null
          });
          return data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async QueryAreaList(value) {
      var that = this;
      return await http
        .post(
          "Lead/GetAreaList",
          qs.stringify({
            province: value,
            staffId: that.staffId
          })
        )
        .then(function(response) {
          var data = response.data;
          data.unshift({
            text: "請選擇城市",
            value: null
          });
          return data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async QueryRegionList(value) {
      var that = this;
      return await http
        .post(
          "Lead/GetRegionList",
          qs.stringify({
            area: value,
            staffId: that.staffId
          })
        )
        .then(function(response) {
          var data = response.data;
          data.unshift({
            text: "請選擇行政區",
            value: null
          });

          return data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    PhoneClick() {
      this.DisplayPhone = true;
    },
    TelPhoneClick() {
      this.DisplayTelPhone = true;
    },
    OtherPhoneClick() {
      this.DisplayOtherPhone = true;
    },
    ProvinceChange(value, type) {
      if (value == null || value == "") {
        return;
      }

      var that = this;
      let data = that.QueryAreaList(value);
      data.then(function(result) {
        if (type == "Address") {
          that.AddressArea = result;
          that.form.contactInfo.AddressArea = null;
          that.AddressRegion = [{ text: "請先選擇城市", value: null }];
          that.form.contactInfo.AddressRegion = null;
        }

        if (type == "ContactAddress") {
          that.ContactAddressArea = result;
          that.form.contactInfo.ContactAddressArea = null;
          that.ContactAddressRegion = [{ text: "請先選擇城市", value: null }];
          that.form.contactInfo.ContactAddressRegion = null;
        }

        if (type == "OfficeAddress") {
          that.OfficeAddressArea = result;
          that.form.OfficeInfo.OfficeAddressArea = null;
          that.OfficeAddressCode = [{ text: "請先選擇城市", value: null }];
          that.form.OfficeInfo.OfficeAddressCode = null;
        }
      });
    },
    AreaChange: function(value, type) {
      if (value == null || value == "") {
        return;
      }
      console.log(type);

      var that = this;
      let data = that.QueryRegionList(value);
      data.then(function(result) {
        if (type == "Address") {
          that.AddressRegion = result;
          that.form.contactInfo.AddressRegion = null;
        }

        if (type == "ContactAddress") {
          that.ContactAddressRegion = result;
          that.form.contactInfo.ContactAddressRegion = null;
        }

        if (type == "OfficeAddress") {
          that.OfficeAddressCode = result;
          that.form.OfficeInfo.OfficeAddressCode = null;
        }
      });
    },

    //取得基本資料修改資料
    GetLeadProfiles() {
      var that = this;
      http
        .post(
          "Lead/GetLeadProfiles",
          qs.stringify({
            leadsn: that.leadSn,
            staffId: that.staffId
          })
        )
        .then(function(response) {
          console.log(response.data.Result.ContactInfo);
          console.log(that.form.contactInfo);
          var data = response.data.Result;
          that.form.BasicInfo = data.BasicInfo;
          that.form.contactInfo = data.ContactInfo;
          that.form.LegalInfo = data.LegalInfo;
          that.form.OfficeInfo = data.OfficeInfo;
          that.form.OtherInfo = data.OtherInfo;

          let province = that.QueryProvinceList();
          province.then(function(result) {
            that.ContactAddressProvince = result;
            that.AddressProvince = result;
          });

          var value = that.form.contactInfo.AddressProvince;
          if (!(value == null || value == "")) {
            data = that.QueryAreaList(value);
            data.then(function(result) {
              that.AddressArea = result;
            });
          }

          value = that.form.contactInfo.ContactAddressProvince;
          if (!(value == null || value == "")) {
            data = that.QueryAreaList(value);
            data.then(function(result) {
              that.ContactAddressArea = result;
            });
          }

          data = that.QueryAreaList("32");
          data.then(function(result) {
            that.OfficeAddressArea = result;
          });

          value = that.form.contactInfo.AddressArea;
          if (!(value == null || value == "")) {
            data = that.QueryRegionList(value);
            data.then(function(result) {
              that.AddressRegion = result;
            });
          }

          value = that.form.contactInfo.ContactAddressArea;
          if (!(value == null || value == "")) {
            data = that.QueryRegionList(value);
            data.then(function(result) {
              that.ContactAddressRegion = result;
            });
          }

          value = that.form.OfficeInfo.OfficeAddressArea;
          if (!(value == null || value == "")) {
            data = that.QueryRegionList(value);
            data.then(function(result) {
              that.OfficeAddressCode = result;
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    onSubmit(evt) {
      evt.preventDefault();
      var that = this;
      if (!that.checkIdNunber(that.form.BasicInfo.IdentityNumber)) {
        alert("個人資料中的身分證字號錯誤！");
        return;
      }
      that.form.StaffId = that.staffId;
      http
        .post("Lead/SaveLeadProfiles", qs.stringify(that.form))
        .then(function(response) {
          var data = response.data;
          if (data.Success) {
            that.$message({
              message: "儲存成功",
              type: "success"
            });

            window.location.href = "#/MobileLeadInfoView?ls=" + that.leadSn;
          } else {
            alert(
              "修改基本資料失敗，錯誤原因:" +
                data.DisplayMessage +
                "，請截圖後聯絡資訊人員。"
            );
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    triggerSubmit(evt) {
      this.visbleFirstBlock = true;
      this.$nextTick(() => {
        $("#sureSubmit").trigger("click");
      });
    },
    maxDay: function() {
      var maxDay = new Date(new Date().setDate(new Date().getDate()));
      return (
        maxDay.getFullYear() +
        "-" +
        this.padLeft((maxDay.getMonth() + 1).toString(), 2) +
        "-" +
        this.padLeft(maxDay.getDate().toString(), 2)
      );
    },
    checkIdNunber(userid) {
      var reg = /^[A-Z]{1}[1-2]{1}[0-9]{8}$/; //身份證的正規表示式
      if (reg.test(userid)) {
        var s = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"; //把A取代成10,把B取代成11...的作法
        var ct = [
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "34",
          "18",
          "19",
          "20",
          "21",
          "22",
          "35",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "32",
          "30",
          "31",
          "33"
        ];
        var i = s.indexOf(userid.charAt(0));
        var tempuserid = ct[i] + userid.substr(1, 9); //若此身份證號若是A123456789=>10123456789
        var num = tempuserid.charAt(0) * 1;
        for (i = 1; i <= 9; i++) {
          num = num + tempuserid.charAt(i) * (10 - i);
        }
        num += tempuserid.charAt(10) * 1;

        if (num % 10 == 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    //todo還沒找到怎麼樣讓formatter傳入參數，只能先這樣寫囉。
    formatMax2(e) {
      return String(e).substring(0, 2);
    },
    formatMax4(e) {
      return String(e).substring(0, 4);
    },
    formatMax6(e) {
      return String(e).substring(0, 6);
    },
    formatMax8(e) {
      return String(e).substring(0, 8);
    },
    formatMax10(e) {
      return String(e).substring(0, 10);
    },
    formatMax15(e) {
      return String(e).substring(0, 15);
    },
    formatMax16(e) {
      return String(e).substring(0, 16);
    },
    formatMax20(e) {
      return String(e).substring(0, 20);
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 5px;
}
#PotentialClientProfileContainer {
  height: calc(100vh - 5px);
  overflow: auto;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 10px 15px;
}
.custom-select:focus {
  box-shadow: none;
  border-color: #ced4da;
}
.form-control,
.custom-select {
  font-size: 14px;
}

input.form-control,
.custom-select {
  margin-bottom: 10px;
}
.custom-control-input:checked ~ .custom-control-label::before {
  background: #b20404 !important;
  border-color: #b20404 !important;
}
</style>

<style>
#birthdayPicker {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  color: #495057;
  padding: 0.25rem 0.5rem;
}
.padding-zero {
  padding: 0px !important;
}
/* #birthdayPicker,
.custom-select,
.form-control-sm {
  border-color: #e8e8e8;
  font-size: 15px;
  padding: 10px;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 6px 0 12px;
} */
</style>


// WEBPACK FOOTER //
// src/components/Main/PotentialClientProfile.vue